import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';
import { MDBDataTableV5, MDBIcon } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import classnames from 'classnames';
import { getUser, getUser_v2 } from '../utils/dropdownlist';
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md';
import { FaEdit } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

class PosScheduleSummary extends React.Component {
  _isMounted = true;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isLoading: true,
      summaryList: [],
      filterList: [],
      sortKey: '',
    };
  }

  componentDidMount() {
    this.ScheduleSummary();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  sortHandler = e => {
    let { value } = e.target;
    this.setState({
      sortKey: value,
    });
    const { summaryList, sortKey } = this.state;
    if (value.length) {
      let item = summaryList.filter(x =>
        JSON.stringify(x).toLowerCase().includes(value.toLowerCase()),
      );
      console.log(item);
      this.setState({ filterList: item });
    } else {
      this.setState({ filterList: summaryList });
    }
  };

  ScheduleSummary() {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };

    axios
      .post(url + ':3001/v1/schedule/summary', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            summaryList: result.data,
            filterList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Row>
          <Col md={4}>
            <Input
              className="ps-input-small"
              name="sortKey"
              value={this.state.sortKey}
              placeholder="Search"
              onChange={this.sortHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Table className="ps-table tb-col-7 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Advance Day</Th>
                  <Th>Minimum Day</Th>
                  <Th>Allow Only Date</Th>
                  <Th>Delivery Pickup</Th>
                  <Th>Start Time</Th>
                  <Th>End Time</Th>
                  <Th>Max Slot</Th>
                  <Th>Date</Th>
                  <Th>Mod Slot</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.filterList.length > 0 &&
                  this.state.filterList.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{item.name}</Td>
                        <Td>{item.advance_days}</Td>
                        <Td>{item.advance_min}</Td>
                        <Td>
                          {' '}
                          <span
                            className={
                              'ps-indicator ' +
                              (item.allow_onlymod == '1' ? 'on' : 'off')
                            }
                          >
                            {item.allow_onlymod == '1' ? 'Yes' : 'No'}
                          </span>
                        </Td>
                        <Td>
                          {' '}
                          <span
                            className={
                              'ps-indicator ' +
                              (item.pickup == '1' ? 'on' : 'off')
                            }
                          >
                            {item.pickup == '1' ? 'Yes' : 'No'}
                          </span>
                        </Td>
                        <Td>{item.starttime}</Td>
                        <Td>{item.endtime}</Td>
                        <Td>{item.max_slot}</Td>
                        <Td>{item.date}</Td>
                        <Td>{item.mod_slot}</Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </>
    );
  }
}

export default PosScheduleSummary;
